import React from 'react';

// Update this one line each release — the download link and the version
// badge shown on the page both read from it, so they can never go out of sync.
const APP_VERSION = '2.4.0';
const DOWNLOAD_URL = `https://github.com/srlbsrpm-cmd/familybandhan-desktop-releases/releases/download/v${APP_VERSION}/FamilyBandhan-Setup.exe`;

export default function Download() {
  const isMobile = /Android|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i.test(navigator.userAgent);

  return (
    <div style={styles.container}>
      <div style={styles.card}>

        {/* Mobile warning banner */}
        {isMobile && (
          <div style={{
            background: '#FEF9C3', border: '1px solid #D4A017',
            borderRadius: '12px', padding: '20px 24px', marginBottom: '28px',
            textAlign: 'center',
          }}>
            <div style={{ fontSize: '28px', marginBottom: '8px' }}>💻</div>
            <p style={{ fontSize: '15px', fontWeight: '700', color: '#1a0533', marginBottom: '6px' }}>
              FamilyBandhan Desktop is for Windows only
            </p>
            <p style={{ fontSize: '13px', color: '#4B5563', lineHeight: 1.7, marginBottom: '16px' }}>
              The desktop app cannot be installed on Android or iPhone.
              To download, please visit this page from a Windows laptop or computer.
            </p>
            <div style={{
              background: '#fff', border: '1px solid #E5E7EB',
              borderRadius: '10px', padding: '14px 16px',
            }}>
              <p style={{ fontSize: '13px', color: '#4B5563', marginBottom: '8px' }}>
                <strong>On mobile?</strong> Use FamilyBandhan online instead — it works on any device with no download needed. Note: it's a separate product with its own feature set and an optional ₹99/year Premium plan for cloud backup, not identical to the desktop app below.
              </p>
              <a href="/"
                style={{
                  display: 'inline-block', background: '#1a0533', color: '#D4A017',
                  padding: '10px 24px', borderRadius: '8px', fontSize: '13px',
                  fontWeight: '600', textDecoration: 'none',
                }}
              >
                🌳 Open FamilyBandhan Online
              </a>
            </div>
          </div>
        )}

        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: '8px' }}>
          <div style={{ ...styles.header, display: 'inline-block' }}>
            <span style={styles.logo}><span style={{ color: '#fff' }}>Family</span><span style={{ color: '#D4A017' }}>Bandhan</span></span>
          </div>
        </div>
        <h1 style={{ textAlign: 'center', fontSize: '26px', color: '#1a0533', marginBottom: '8px' }}>FamilyBandhan Desktop</h1>
        <p style={{ textAlign: 'center', fontSize: '14px', color: '#6B7280', marginBottom: '8px', lineHeight: 1.6 }}>
          Your family tree. On your device. Forever private.
        </p>
        <p style={{ textAlign: 'center', fontSize: '13px', color: '#9CA3AF', marginBottom: '32px' }}>
          Windows · 100% free · Any language · Works fully offline · No account, no cloud
          <br />
          <span style={{ fontSize: '11px', color: '#D1D5DB' }}>Version {APP_VERSION}</span>
        </p>

        {/* Feature card */}
        <div style={styles.priceCard}>
          <div style={{ fontSize: '40px', fontWeight: '700', color: '#D4A017', lineHeight: 1 }}>Free</div>
          <div style={{ fontSize: '13px', color: '#9CA3AF', marginBottom: '20px' }}>
            Unlimited family trees · Works fully offline · Yours forever
          </div>
          <p style={{ fontSize: '14px', color: '#4B5563', lineHeight: 1.8, marginBottom: '24px', textAlign: 'left' }}>
            ✓ Unlimited family members, generations, branches<br/>
            ✓ Link separate family trees together into one connected network<br/>
            ✓ Profile photos and unlimited story photos<br/>
            ✓ Family Gallery, Traditions, and Events modules<br/>
            ✓ Stories, notes, and birthdays for every member<br/>
            ✓ Everything saved privately on your device — never in the cloud
          </p>

          <a
          
            href={isMobile ? undefined : DOWNLOAD_URL}
            style={{
              ...styles.downloadBtn,
              display: 'block',
              background: isMobile ? '#9CA3AF' : '#D4A017',
              color: '#0e0018',
              cursor: isMobile ? 'not-allowed' : 'pointer',
              pointerEvents: isMobile ? 'none' : 'auto',
            }}
          >
            ⬇ Download FamilyBandhan Desktop
          </a>
          <p style={{ fontSize: '12px', color: '#9CA3AF', marginTop: '12px' }}>Windows only</p>
          <p style={{ fontSize: '11px', color: '#B0B4BC', marginTop: '4px' }}>Requires Windows 10 or later</p>
        </div>

        {/* Security warning notice — generic, no antivirus product named */}
        <div style={{
          marginTop: '20px', padding: '16px 18px',
          background: '#F3F4F6', border: '1px solid #E5E7EB',
          borderRadius: '10px', fontSize: '12.5px', color: '#4B5563', lineHeight: 1.7,
        }}>
          <strong style={{ color: '#1a0533' }}>⚠️ Seeing a security warning during install?</strong><br/>
          Some antivirus software may show a warning about the installer "modifying system files" while FamilyBandhan Desktop sets itself up. This is a known false positive with installers built using standard Windows packaging tools — it is not a virus, and FamilyBandhan Desktop works completely offline and never sends your data anywhere.
          <br/><br/>
          If you see this warning, click <strong>"Allow"</strong> promptly — some antivirus tools auto-block after a short countdown if you don't respond in time. If it was accidentally blocked, uninstall FamilyBandhan Desktop completely and reinstall, choosing "Allow" this time.
        </div>

        {/* Footer */}
        <div style={styles.footer}>
          <a href="/" style={styles.link}>← Back to FamilyBandhan</a>
          <span style={styles.sep}>·</span>
          <a href="/terms" style={styles.link}>Terms</a>
          <span style={styles.sep}>·</span>
          <a href="/privacy" style={styles.link}>Privacy</a>
        </div>
      </div>
    </div>
  );
}

const styles = {
  container: {
    minHeight: '100vh', background: '#f8f7ff',
    padding: '32px 16px', fontFamily: "'DM Sans', Arial, sans-serif",
  },
  card: {
    maxWidth: '560px', margin: '0 auto', background: '#ffffff',
    borderRadius: '16px', padding: '40px 36px',
    boxShadow: '0 2px 16px rgba(0,0,0,0.08)',
  },
  header: {
    marginBottom: '20px', fontFamily: "'Cormorant Garamond', serif",
    fontSize: '22px', background: '#0e0018',
    padding: '10px 20px', borderRadius: '8px',
  },
  logo: { letterSpacing: '0.5px' },
  priceCard: {
    border: '2px solid #D4A017', borderRadius: '14px',
    padding: '32px 28px', textAlign: 'center',
    background: '#FFFBEB',
  },
  downloadBtn: {
    padding: '14px', border: 'none', borderRadius: '10px',
    fontSize: '15px', fontWeight: '700', textAlign: 'center',
    textDecoration: 'none',
    fontFamily: "'DM Sans', Arial, sans-serif",
  },
  footer: {
    marginTop: '40px', paddingTop: '20px',
    borderTop: '1px solid #E5E7EB',
    display: 'flex', gap: '8px', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'center',
  },
  link: { fontSize: '13px', color: '#7C3AED', textDecoration: 'none' },
  sep: { color: '#D1D5DB', fontSize: '13px' },
};